import { useTelegramUsersGetMe } from '@/generated';
import { useIsLogined } from '@/contexts/LoginContext';

export const UNREAD_POLL_QUERY_KEY = ['get-me-unread-poll'];

export const useUnreadConnectionsCount = () => {
  const isLogined = useIsLogined();

  const { data } = useTelegramUsersGetMe({
    query: {
      queryKey: UNREAD_POLL_QUERY_KEY,
      enabled: isLogined,
      refetchInterval: 45_000,
      refetchOnWindowFocus: true,
      select: (me) => me?.unreadIncomingConnectionsCount ?? 0,
      meta: { disableDefaultError: true },
    },
    client: {
      handle401: false,
    },
  });

  return isLogined ? (data ?? 0) : 0;
};
